import { CustomFieldDefinition } from '__types__';
import { TFunction } from 'i18next';
import { CustomFieldTypeIcon } from 'v5/patterns/widgets/customFieldTypeIcons';
import { customFilter } from 'v5/core/standard-date-filter/custom-filter';
import { FilterDateConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createDateFilterConfig(
  customFieldDef: CustomFieldDefinition,
  t: TFunction<'core'>
): FilterDateConfig<any> {
  return {
    ...customFilter.createFilterConfig(customFieldDef.name, t),
    icon: <CustomFieldTypeIcon type={customFieldDef.data_type} />
  };
}
